import { axiosInstanceAuth } from "./client"
import { useMutation, useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios";
import { BaseResponse, ErrorResponse, IChangePassword, User } from "interfaces"

export const useGetUserImage = (id: number) => {
    return useQuery({
      queryKey: ['GET IMAGE USER'],
      queryFn: async () => {
        const res = await axiosInstanceAuth.get(`/users/${id}`);
        return res as BaseResponse<User>;
      },
      enabled: !!id
    });
  };
  
  
export const useUpdateImageUser = (onOk?: Function, onErr?: Function) => {
  return useMutation({
    mutationKey: ['UPDATE IMAGE USER'],
    mutationFn: ({ id, imageUrl }: { id: number, imageUrl: string }) =>  axiosInstanceAuth.put(`/users/${id}`, {
      user: {
        imageUrl
      }
    }),
    onSuccess: (res) => {
      onOk && onOk(res)
    },
    onError: (err) => {
        onErr && onErr(err)
    }
  })
} 
export const useDeleteCurrentUser = (onOk?: Function, onErr?: Function) => {
  return useMutation({
    mutationKey: ['DELETE_CURRENT_USER'],
    mutationFn: (id: number) =>  axiosInstanceAuth.delete(`/users/${id}`),
    onSuccess: (res) => {
      onOk && onOk(res)
    },
    onError: (err) => {
        onErr && onErr(err)
    }
  })
}

export const userChangePassword = (body :IChangePassword):Promise<any> => {
  return axiosInstanceAuth.patch("users/change_password" , body)
}
export const useUserChangePassword = (onOk?: (res: BaseResponse) => void, onErr?: (err: AxiosError<ErrorResponse>) => void) => {
  return useMutation({
    mutationKey: ['CHANGE_PASSWORD_MUTATION'],
    mutationFn: (body: IChangePassword) => userChangePassword(body),
    onSuccess: (res: BaseResponse) => {
      onOk && onOk(res)
    },
    onError: (err: AxiosError<ErrorResponse>) => {
        onErr && onErr(err)
    }
  })
}